// saleNoActionTypes.js
export const GET_SALE_NO_REQUEST = 'GET_SALE_NO_REQUEST';
export const GET_SALE_NO_SUCCESS = 'GET_SALE_NO_SUCCESS';
export const GET_SALE_NO_FAILURE = 'GET_SALE_NO_FAILURE';

// sale number list
export const CHECK_SALE_NO_EXISTENCE = 'CHECK_SALE_NO_EXISTENCE';
export const CHECK_SALE_NO_EXISTENCE_SUCCESS = 'CHECK_SALE_NO_EXISTENCE_SUCCESS';
export const CHECK_SALE_NO_EXISTENCE_FAILURE = 'CHECK_SALE_NO_EXISTENCE_FAILURE';

// sale program list
export const FETCH_SALE_PROGRAM_LIST_REQUEST = 'FETCH_SALE_PROGRAM_LIST_REQUEST';
export const FETCH_SALE_PROGRAM_LIST_SUCCESS = 'FETCH_SALE_PROGRAM_LIST_SUCCESS';
export const FETCH_SALE_PROGRAM_LIST_FAILURE = 'FETCH_SALE_PROGRAM_LIST_FAILURE';

// sale program detailed screen
export const FETCH_SALE_PROGRAM_DETAILS_REQUEST = 'FETCH_SALE_PROGRAM_DETAILS_REQUEST';
export const FETCH_SALE_PROGRAM_DETAILS_SUCCESS = 'FETCH_SALE_PROGRAM_DETAILS_SUCCESS';
export const FETCH_SALE_PROGRAM_DETAILS_FAILURE = 'FETCH_SALE_PROGRAM_DETAILS_FAILURE';

// create sale program
export const CREATE_SALE_PROGRAM_REQUEST = 'CREATE_SALE_PROGRAM_REQUEST';
export const CREATE_SALE_PROGRAM_SUCCESS = 'CREATE_SALE_PROGRAM_SUCCESS';
export const CREATE_SALE_PROGRAM_FAILURE = 'CREATE_SALE_PROGRAM_FAILURE';

// update sale program
export const UPDATE_SALE_PROGRAM_REQUEST = 'UPDATE_SALE_PROGRAM_REQUEST';
export const UPDATE_SALE_PROGRAM_SUCCESS = 'UPDATE_SALE_PROGRAM_SUCCESS';
export const UPDATE_SALE_PROGRAM_FAILURE = 'UPDATE_SALE_PROGRAM_FAILURE';

// cancel sale program
export const CANCEL_SALE_PROGRAM_REQUEST = 'CANCEL_SALE_PROGRAM_REQUEST';
export const CANCEL_SALE_PROGRAM_SUCCESS = 'CANCEL_SALE_PROGRAM_SUCCESS';
export const CANCEL_SALE_PROGRAM_FAILURE = 'CANCEL_SALE_PROGRAM_FAILURE';

// cancel sale program document
export const CANCEL_SALE_PROGRAM_DOCUMENT_REQUEST = "CANCEL_SALE_PROGRAM_DOCUMENT_REQUEST";
export const CANCEL_SALE_PROGRAM_DOCUMENT_SUCCESS = "CANCEL_SALE_PROGRAM_DOCUMENT_SUCCESS";
export const CANCEL_SALE_PROGRAM_DOCUMENT_FAILURE = "CANCEL_SALE_PROGRAM_DOCUMENT_FAILURE";

